import { render, staticRenderFns } from "./review-slider-yuri.vue?vue&type=template&id=6e51bedd&scoped=true&"
import script from "./review-slider-yuri.vue?vue&type=script&lang=js&"
export * from "./review-slider-yuri.vue?vue&type=script&lang=js&"
import style0 from "./review-slider-yuri.vue?vue&type=style&index=0&id=6e51bedd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e51bedd",
  null
  
)

export default component.exports